import Vue from 'vue';

import App from '@/components/App';
import Team from '@/components/Team';
import BaseHero from '@/components/BaseHero';
import BrandBlog from '@/components/BrandBlog';
import BasePanel from '@/components/BasePanel';
import BaseHeader from '@/components/BaseHeader';
import VideoModal from '@/components/VideoModal';
import ContactForm from '@/components/ContactForm';
import BrandServices from '@/components/BrandServices';
import BrandTimeline from '@/components/BrandTimeline';
import BaseAccordian from '@/components/BaseAccordian';
import BrandProfiles from '@/components/BrandProfiles';
import SearchResults from '@/components/SearchResults';

import vueSmoothScroll from 'vue-smooth-scroll';
import VueYouTubeEmbed from 'vue-youtube-embed';
import objectFitImages from 'object-fit-images';
import WOW from 'wowjs';

require('intersection-observer');
require('es6-promise').polyfill();

Vue.use(vueSmoothScroll);
Vue.use(VueYouTubeEmbed);

objectFitImages();

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    components: {
        App,
        Team,
        BaseHero,
        BasePanel,
        BrandBlog,
        BaseHeader,
        VideoModal,
        ContactForm,
        BrandProfiles,
        BrandServices,
        BrandTimeline,
        BaseAccordian,
        SearchResults,
    },
});

const wow = new WOW.WOW(
    {
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
        scrollContainer: null,
    },
);

wow.init();



// WEBPACK FOOTER //
// ./src/js/main.js